import { graphql } from "react-relay";

export const flowStatePollerFragments = {
  flowState: graphql`
    fragment FlowStatePoller_flowState on FlowState {
      id
      flowKey
      previousState
      current {
        state
        percentComplete
        errorMessage
      }
      pending {
        state
        percentComplete
        errorMessage
      }
    }
  `,
};

export const flowStatePollerQuery = graphql`
  query FlowStatePollerQuery($flowStateRelayId: ID!) {
    flowState: node(id: $flowStateRelayId) {
      ... on FlowState {
        ...FlowStatePoller_flowState
      }
    }
  }
`;
